module.exports = __webpack_public_path__ + "static/media/hs_19.2b4350b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_19.jpg
// module id = 5950
// module chunks = 0